import { Select } from "antd";
import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import Explain from "../Explain";
import { StatusType } from "../Explain/types";
import { InputPropsType } from "./InputPropsT";
import { ReactComponent as Check } from "../../../assets/icons/Check.svg";

interface SelectProps extends InputPropsType {
  onChange: (e: any) => void;
  selectArray?: { id: number; value: string | number }[];
  status?: StatusType;
  explain?: string;
  onExplainClick?: () => void;
}

const SelectGroup: React.FC<SelectProps> = ({
  children,
  disabled,
  placeholder,
  name,
  defaultValue,
  value,
  status,
  explain,
  onExplainClick,
  selectArray,
  onChange,
}) => {
  const styles = {
    disabled,
    placeholder,
    value,
    name,
  };
  return (
    <>
      <SelectInput
        {...styles}
        bordered={false}
        size="large"
        defaultValue={defaultValue}
        onChange={onChange}
        dropdownStyle={{ minWidth: "300px" }}
        menuItemSelectedIcon={<Check />}
      >
        {/* childre이 있을 경우 children */}
        {/* children이 없을 경우 map으로 자식들을 순회함 */}
        {selectArray === undefined
          ? children
          : selectArray.map((e) => (
              <Select.Option key={e.id} value={e.value}>
                {e.value}
              </Select.Option>
            ))}
      </SelectInput>
      {explain && explain.length > 0 && (
        <Explain explain={explain} onClick={onExplainClick} status={status} />
      )}
    </>
  );
};

export default SelectGroup;

const SelectInput = styled(Select)<{ status?: StatusType }>`
  background-color: #fff;

  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  border-color: ${({ status }) =>
    status === "error"
      ? theme.colors.red3
      : status === "success"
      ? theme.colors.blue2
      : "black"};
  ::placeholder {
    color: #6e6e6e;
  }
  border-bottom: 1px solid ${theme.colors.gray6};
  border-radius: 0;

  :focus {
    border-color: ${theme.colors.mainPrimary3};
  }
  transition: all 0.3s;
  line-height: 24px;
  margin-top: 16px;
`;
